import { render } from "./AgentRenewLicenseAdditionalDocView.vue?vue&type=template&id=164adb7a&scoped=true"
import script from "./AgentRenewLicenseAdditionalDocView.vue?vue&type=script&lang=js"
export * from "./AgentRenewLicenseAdditionalDocView.vue?vue&type=script&lang=js"

import "./AgentRenewLicenseAdditionalDocView.vue?vue&type=style&index=0&id=164adb7a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164adb7a"]])

export default __exports__